const initialState = {
    data: null, isLoading: true, isRejected: false
}

export default (state = initialState, action) => {
    switch (action.type) {             
        case 'LOAD_ACADEMIC_RESULT_PENDING':
            return { data: null, isLoading: true, isRejected: false }
        case 'LOAD_ACADEMIC_RESULT_SUCCESS':
            return { data: action.payload, isLoading: false, isRejected: false }
        case 'LOAD_ACADEMIC_RESULT_REJECTED':
            console.log('action 555 ', action.payload)
            return { data: action.payload, isLoading: false, isRejected: true  }
        default:
            return state
    }
}